import { Field } from 'formik';
import {
  Dropdown,
  Icon,
  Popup,
  // Form as SemanticForm
} from 'semantic-ui-react';

// Custom Input component with error popups
export const CustomInput = ({ label, error, fluid, ...props }) => {
  // Extract fluid prop and use it for styling
  const inputStyle = {
    width: fluid ? '100%' : 'auto',
    padding: '0.67857143em 1em',
    border: error ? '1px solid #e0b4b4' : '1px solid rgba(34,36,38,.15)',
    borderRadius: '.28571429rem',
    transition: 'box-shadow .1s ease,border-color .1s ease',
    backgroundColor: error ? '#fff6f6' : 'transparent',
    ...props.style
  };

  return (
    <div style={{ marginBottom: '1em' }}>
      {label && (
        <label style={{ display: 'block', marginBottom: '0.1em', fontWeight: '500' }}>
          {label}
          {error && (
            <Popup
              content={error}
              trigger={
                <Icon
                  name="exclamation circle"
                  color="red"
                  style={{ marginLeft: '0.5em', cursor: 'pointer' }}
                />
              }
              position="top center"
              size="tiny"
            />
          )}
        </label>
      )}
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }}>
        <input
          {...props}
          style={inputStyle}
        // fluid is not passed to input element
        />
      </div>
    </div>
  );
};

// Formik wrapper for CustomInput
// export const FormikInput = ({ field, form, label, ...props }) => {
//   const hasError = form.touched[field.name] && form.errors[field.name];

//   return (
//     <CustomInput
//       {...field}
//       {...props}
//       label={label}
//       error={hasError ? form.errors[field.name] : null}
//       onChange={(e) => form.setFieldValue(field.name, e.target.value)}
//       onBlur={() => form.setFieldTouched(field.name, true)}
//     />
//   );
// };
export const FormikInput = ({ field, form, label, onChange, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <CustomInput
      {...field}
      {...props}
      label={label}
      error={hasError ? form.errors[field.name] : null}
      onChange={(e) => {
        form.setFieldValue(field.name, e.target.value);
        if (onChange) onChange(e);  // ✅ ADD THIS LINE
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
    />
  );
};

// Custom TextArea component with error popups
export const CustomTextArea = ({ label, error, fluid, rows = 3, ...props }) => {
  // Extract fluid and rows props and use them for styling
  const textareaStyle = {
    width: '100%', // Always use 100% instead of conditional width
    padding: '0.67857143em 1em',
    border: error ? '1px solid #e0b4b4' : '1px solid rgba(34,36,38,.15)',
    borderRadius: '.28571429rem',
    transition: 'box-shadow .1s ease,border-color .1s ease',
    backgroundColor: error ? '#fff6f6' : 'transparent',
    minHeight: `${rows * 2.5}em`,
    resize: 'vertical',
    boxSizing: 'border-box', // This ensures padding is included in width calculation
    ...props.style
  };

  return (
    // <div style={{ marginBottom: '1em' }}>
    <div >

      {label && (
        <label style={{ display: 'block', marginBottom: '0.5em', fontWeight: '500' }}>
          {label}
          {error && (
            <Popup
              content={error}
              trigger={
                <Icon
                  name="exclamation circle"
                  color="red"
                  style={{ marginLeft: '0.5em', cursor: 'pointer' }}
                />
              }
              position="top center"
              size="tiny"
            />
          )}
        </label>
      )}
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%' // Ensure the container takes full width
      }}>
        <textarea
          {...props}
          style={textareaStyle}
          rows={rows}
        />
        {error && (
          <Popup
            content={error}
            trigger={
              <Icon
                name="exclamation circle"
                color="red"
                style={{
                  position: 'absolute',
                  right: '0.5em',
                  top: '0.5em',
                  pointerEvents: 'auto',
                  cursor: 'pointer'
                }}
              />
            }
            position="top right"
            size="tiny"
          />
        )}
      </div>
    </div>
  );
};

// Formik wrapper for CustomTextArea
// export const FormikTextArea = ({ field, form, label, ...props }) => {
//   const hasError = form.touched[field.name] && form.errors[field.name];
//   return (
//     <CustomTextArea
//       {...field}
//       {...props}
//       label={label}
//       error={hasError ? form.errors[field.name] : null}
//       onChange={(e) => form.setFieldValue(field.name, e.target.value)}
//       onBlur={() => form.setFieldTouched(field.name, true)}
//     />
//   );
// };
export const FormikTextArea = ({ field, form, label, onChange, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];
  return (
    <CustomTextArea
      {...field}
      {...props}
      label={label}
      error={hasError ? form.errors[field.name] : null}
      onChange={(e) => {
        form.setFieldValue(field.name, e.target.value);
        if (onChange) onChange(e);  // ✅ CALL CUSTOM onChange
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
    />
  );
};

// Formik Select component
export const FormikSelect = ({ field, form, options, label, placeholder, onChange, search, loading, disabled, ...props }) => (
  <div style={{
    marginTop: '0.0em',  // Maintain spacing similar to a form field
    position: 'relative'  // Create a new stacking context
  }}>
    {label && <label style={{ display: 'block', marginBottom: '0.1em', fontWeight: 'bold' }}>{label}</label>}
    <Dropdown
      selection
      search={search}
      loading={loading}
      disabled={disabled}
      options={options}
      value={field.value}
      placeholder={placeholder}
      onChange={(e, { value }) => {
        form.setFieldValue(field.name, value);
        if (onChange) onChange(e, { value });  // Call custom onChange handler
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
      error={form.errors[field.name] && form.touched[field.name]}
      fluid
      style={{
        ...props.style,
      }}
    />
  </div>
);

// Custom Checkbox component with error popups
export const CustomCheckbox = ({ label, error, checked, ...props }) => {
  return (
    <div style={{ marginBottom: '1em', position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            position: 'relative',
            width: '20px',
            height: '20px',
            marginRight: '0.5em',
            border: '1px solid #333',
            backgroundColor: 'white',
            borderRadius: '3px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}
        >
          <input
            type="checkbox"
            {...props}
            style={{
              position: 'absolute',
              opacity: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
              zIndex: 2,
              ...props.style
            }}
          />
          {checked && (
            <Icon
              name="check"
              style={{
                color: '#2185d0',
                fontSize: '16px',
                position: 'absolute',
                zIndex: 1
              }}
            />
          )}
        </div>
        <label style={{ margin: 0, cursor: 'pointer', fontWeight: 'bold' }}>
          {label}
          {error && (
            <Popup
              content={error}
              trigger={
                <Icon
                  name="exclamation circle"
                  color="red"
                  style={{ marginLeft: '0.5em', cursor: 'pointer' }}
                />
              }
              position="top center"
              size="tiny"
            />
          )}
        </label>
      </div>
    </div>
  );
};

// Formik wrapper for CustomCheckbox
export const FormikCheckbox = ({ field, form, label, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <CustomCheckbox
      {...field}
      {...props}
      label={label}
      error={hasError ? form.errors[field.name] : null}
      checked={field.value}
      onChange={(e) => form.setFieldValue(field.name, e.target.checked)}
      onBlur={() => form.setFieldTouched(field.name, true)}
    />
  );
};

// Export a component that includes all Formik fields
export const FormikField = (props) => {
  const { component, ...rest } = props;
  return (
    <Field
      component={component}
      {...rest}
    />
  );
};
// Custom NumberInput component with error popups
export const CustomNumberInput = ({ label, error, fluid, maxInputWidth, min, max, step, ...props }) => {
  const inputStyle = {
    width: fluid ? '100%' : 'auto',
    maxWidth: maxInputWidth ? maxInputWidth : 'auto',
    padding: '0.67857143em 1em',
    border: error ? '1px solid #e0b4b4' : '1px solid rgba(34,36,38,.15)',
    borderRadius: '.28571429rem',
    transition: 'box-shadow .1s ease,border-color .1s ease',
    backgroundColor: error ? '#fff6f6' : 'transparent',
    ...props.style
  };

  return (
    <div style={{ marginBottom: '1em' }}>
      {label && (
        <label style={{ display: 'block', marginBottom: '0.1em', fontWeight: '500' }}>
          {label}
          {error && (
            <Popup
              content={error}
              trigger={
                <Icon
                  name="exclamation circle"
                  color="red"
                  style={{ marginLeft: '0.5em', cursor: 'pointer' }}
                />
              }
              position="top center"
              size="tiny"
            />
          )}
        </label>
      )}
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
      }}>
        <input
          type="number"
          min={min}
          max={max}
          step={step}
          {...props}
          style={inputStyle}
        />
      </div>
    </div>
  );
};

// Formik wrapper for CustomNumberInput
export const FormikNumberInput = ({ field, form, label, min, max, step, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <CustomNumberInput
      {...field}
      {...props}
      label={label}
      error={hasError ? form.errors[field.name] : null}
      min={min}
      max={max}
      step={step}
      onChange={(e) => {
        const value = e.target.value;
        // Parse as integer or float based on step
        const parsedValue = step && step % 1 !== 0 ? parseFloat(value) : parseInt(value);
        form.setFieldValue(field.name, isNaN(parsedValue) ? '' : parsedValue);
      }}
      onBlur={() => form.setFieldTouched(field.name, true)}
    />
  );
};

const FormComponents = {
  CustomInput,
  FormikInput,
  CustomTextArea,
  FormikTextArea,
  FormikSelect,
  CustomCheckbox,
  FormikCheckbox,
  FormikField,
  FormikNumberInput
};

export default FormComponents;
